/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const DiscountPercentage: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6 7C6 6.44772 6.44772 6 7 6C7.55228 6 8 6.44772 8 7C8 7.55228 7.55228 8 7 8C6.44772 8 6 7.55228 6 7ZM7 4C5.34315 4 4 5.34315 4 7C4 8.65685 5.34315 10 7 10C8.65685 10 10 8.65685 10 7C10 5.34315 8.65685 4 7 4ZM19.2071 4.79289C19.5976 5.18342 19.5976 5.81658 19.2071 6.20711L6.20711 19.2071C5.81658 19.5976 5.18342 19.5976 4.79289 19.2071C4.40237 18.8166 4.40237 18.1834 4.79289 17.7929L17.7929 4.79289C18.1834 4.40237 18.8166 4.40237 19.2071 4.79289ZM17 16C16.4477 16 16 16.4477 16 17C16 17.5523 16.4477 18 17 18C17.5523 18 18 17.5523 18 17C18 16.4477 17.5523 16 17 16ZM14 17C14 15.3431 15.3431 14 17 14C18.6569 14 20 15.3431 20 17C20 18.6569 18.6569 20 17 20C15.3431 20 14 18.6569 14 17Z'
      fill='currentColor'
    />
  </React.Fragment>
)
